import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const putUserProfile = (data) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ADMIN.USER_MANAGEMENT.PUT_USER_PROFILE(data.iscustomlogin),
    data
  );
};

export default putUserProfile;
